module.exports = __webpack_public_path__ + "../resources/img/ic_up_arrow.621af903.svg";